jQuery.feature_import("js-energy-distribution-chart",
  () => require("./react-pie-chart.js"),
  mod => mod.feature_js_energy_distribution_chart
);